export {default} from '../../../core/components/Repository/DetailFormPopup';